__turbopack_context__.v({
  "banner": "mlrPFG_banner",
  "danger": "mlrPFG_danger",
  "icon": "mlrPFG_icon",
  "link": "mlrPFG_link",
  "marquee": "mlrPFG_marquee",
  "message": "mlrPFG_message",
  "notice-marquee": "mlrPFG_notice-marquee",
  "static": "mlrPFG_static",
  "track": "mlrPFG_track",
  "warning": "mlrPFG_warning",
});
